<div class="hashi-board">
  <svg [attr.viewBox]="'0 0 ' + widthPX + ' ' + heightPX" [attr.width]="'100%'" [attr.height]="'100%'" preserveAspectRatio="xMidYMid meet">
    <!-- Bridges -->
    <g class="bridges">
      <ng-container *ngFor="let key of bridgeKeys">
        <ng-container [ngSwitch]="getOrientation(key)">
          <g *ngSwitchCase="'h'" (click)="cycleBridge(key)" (mouseenter)="enterBridge(key)" (mouseleave)="leaveBridge()" style="cursor:pointer">
            <!-- Invisible hit area to allow clicking anywhere between islands -->
            <line
              [attr.x1]="lineH(key).x1"
              [attr.y1]="lineH(key).y1"
              [attr.x2]="lineH(key).x2"
              [attr.y2]="lineH(key).y2"
              stroke="#000"
              [attr.stroke-opacity]="0"
              [attr.stroke-width]="hitStrokeWidth"
              style="pointer-events: stroke"
            />
            <!-- Preview (hover/drag): single or double line depending on next state -->
            <line
              *ngIf="getPreviewCountFor(key) === 1"
              [attr.x1]="lineH(key).x1"
              [attr.y1]="lineH(key).y1"
              [attr.x2]="lineH(key).x2"
              [attr.y2]="lineH(key).y2"
              stroke="#1976d2"
              [attr.stroke-width]="bridgeStroke"
              stroke-linecap="round"
              [attr.stroke-opacity]="0.6"
              stroke-dasharray="6 6"
            />
            <line
              *ngIf="getPreviewCountFor(key) >= 2"
              [attr.x1]="lineH(key).x1"
              [attr.y1]="lineH(key).y1 - bridgeOffset"
              [attr.x2]="lineH(key).x2"
              [attr.y2]="lineH(key).y2 - bridgeOffset"
              stroke="#1976d2"
              [attr.stroke-width]="bridgeStroke"
              stroke-linecap="round"
              [attr.stroke-opacity]="0.6"
              stroke-dasharray="6 6"
            />
            <line
              *ngIf="getPreviewCountFor(key) >= 2"
              [attr.x1]="lineH(key).x1"
              [attr.y1]="lineH(key).y1 + bridgeOffset"
              [attr.x2]="lineH(key).x2"
              [attr.y2]="lineH(key).y2 + bridgeOffset"
              stroke="#1976d2"
              [attr.stroke-width]="bridgeStroke"
              stroke-linecap="round"
              [attr.stroke-opacity]="0.6"
              stroke-dasharray="6 6"
            />
            <!-- Single bridge centered -->
            <line
              *ngIf="bridges[serializeKey(key)] === 1"
              [attr.x1]="lineH(key).x1"
              [attr.y1]="lineH(key).y1"
              [attr.x2]="lineH(key).x2"
              [attr.y2]="lineH(key).y2"
              stroke="#444"
              [attr.stroke-width]="bridgeStroke"
              stroke-linecap="round"
            />
            <!-- Double bridges offset -->
            <line
              *ngIf="bridges[serializeKey(key)] >= 2"
              [attr.x1]="lineH(key).x1"
              [attr.y1]="lineH(key).y1 - bridgeOffset"
              [attr.x2]="lineH(key).x2"
              [attr.y2]="lineH(key).y2 - bridgeOffset"
              stroke="#444"
              [attr.stroke-width]="bridgeStroke"
              stroke-linecap="round"
            />
            <line
              *ngIf="bridges[serializeKey(key)] >= 2"
              [attr.x1]="lineH(key).x1"
              [attr.y1]="lineH(key).y1 + bridgeOffset"
              [attr.x2]="lineH(key).x2"
              [attr.y2]="lineH(key).y2 + bridgeOffset"
              stroke="#444"
              [attr.stroke-width]="bridgeStroke"
              stroke-linecap="round"
            />
          </g>
          <g *ngSwitchCase="'v'" (click)="cycleBridge(key)" (mouseenter)="enterBridge(key)" (mouseleave)="leaveBridge()" style="cursor:pointer">
            <!-- Invisible hit area to allow clicking anywhere between islands -->
            <line
              [attr.x1]="lineV(key).x1"
              [attr.y1]="lineV(key).y1"
              [attr.x2]="lineV(key).x2"
              [attr.y2]="lineV(key).y2"
              stroke="#000"
              [attr.stroke-opacity]="0"
              [attr.stroke-width]="hitStrokeWidth"
              style="pointer-events: stroke"
            />
            <!-- Preview (hover/drag): single or double line depending on next state -->
            <line
              *ngIf="getPreviewCountFor(key) === 1"
              [attr.x1]="lineV(key).x1"
              [attr.y1]="lineV(key).y1"
              [attr.x2]="lineV(key).x2"
              [attr.y2]="lineV(key).y2"
              stroke="#1976d2"
              [attr.stroke-width]="bridgeStroke"
              stroke-linecap="round"
              [attr.stroke-opacity]="0.6"
              stroke-dasharray="6 6"
            />
            <line
              *ngIf="getPreviewCountFor(key) >= 2"
              [attr.x1]="lineV(key).x1 - bridgeOffset"
              [attr.y1]="lineV(key).y1"
              [attr.x2]="lineV(key).x2 - bridgeOffset"
              [attr.y2]="lineV(key).y2"
              stroke="#1976d2"
              [attr.stroke-width]="bridgeStroke"
              stroke-linecap="round"
              [attr.stroke-opacity]="0.6"
              stroke-dasharray="6 6"
            />
            <line
              *ngIf="getPreviewCountFor(key) >= 2"
              [attr.x1]="lineV(key).x1 + bridgeOffset"
              [attr.y1]="lineV(key).y1"
              [attr.x2]="lineV(key).x2 + bridgeOffset"
              [attr.y2]="lineV(key).y2"
              stroke="#1976d2"
              [attr.stroke-width]="bridgeStroke"
              stroke-linecap="round"
              [attr.stroke-opacity]="0.6"
              stroke-dasharray="6 6"
            />
            <!-- Single bridge centered -->
            <line
              *ngIf="bridges[serializeKey(key)] === 1"
              [attr.x1]="lineV(key).x1"
              [attr.y1]="lineV(key).y1"
              [attr.x2]="lineV(key).x2"
              [attr.y2]="lineV(key).y2"
              stroke="#444"
              [attr.stroke-width]="bridgeStroke"
              stroke-linecap="round"
            />
            <!-- Double bridges offset -->
            <line
              *ngIf="bridges[serializeKey(key)] >= 2"
              [attr.x1]="lineV(key).x1 - bridgeOffset"
              [attr.y1]="lineV(key).y1"
              [attr.x2]="lineV(key).x2 - bridgeOffset"
              [attr.y2]="lineV(key).y2"
              stroke="#444"
              [attr.stroke-width]="bridgeStroke"
              stroke-linecap="round"
            />
            <line
              *ngIf="bridges[serializeKey(key)] >= 2"
              [attr.x1]="lineV(key).x1 + bridgeOffset"
              [attr.y1]="lineV(key).y1"
              [attr.x2]="lineV(key).x2 + bridgeOffset"
              [attr.y2]="lineV(key).y2"
              stroke="#444"
              [attr.stroke-width]="bridgeStroke"
              stroke-linecap="round"
            />
          </g>
        </ng-container>
      </ng-container>
    </g>
    <!-- Nodes -->
    <g class="nodes">
      <g
        *ngFor="let n of islands"
        (mousedown)="mouseDownIsland(n)"
        (mouseup)="mouseUpIsland(n)"
        (mouseenter)="enterIsland(n)"
        (mouseleave)="leaveIsland()"
        (click)="$event.stopPropagation()"
        style="cursor:pointer"
      >
        <circle
          [attr.cx]="islandCenter(n).x"
          [attr.cy]="islandCenter(n).y"
          [attr.r]="islandRadius"
          [attr.fill]="isIslandSatisfied(n) ? '#ddd' : '#fff'"
          [attr.stroke]="isIslandSatisfied(n) ? '#aaa' : '#222'"
          [attr.stroke-width]="2"
        />
        <text
          [attr.x]="islandCenter(n).x"
          [attr.y]="islandCenter(n).y + 5"
          text-anchor="middle"
          font-size="16"
          [attr.fill]="isIslandSatisfied(n) ? '#888' : '#222'"
        >
          {{ n.requiredBridges }}
        </text>
        <!-- Red cross when node is overpopulated (only if showing errors is enabled) -->
        <line
          *ngIf="showErrorsImmediately && isIslandOverpopulated(n)"
          [attr.x1]="islandCenter(n).x - islandRadius * 0.9"
          [attr.y1]="islandCenter(n).y - islandRadius * 0.9"
          [attr.x2]="islandCenter(n).x + islandRadius * 0.9"
          [attr.y2]="islandCenter(n).y + islandRadius * 0.9"
          stroke="#d00"
          stroke-width="3"
          stroke-linecap="round"
        />
        <line
          *ngIf="showErrorsImmediately && isIslandOverpopulated(n)"
          [attr.x1]="islandCenter(n).x - islandRadius * 0.9"
          [attr.y1]="islandCenter(n).y + islandRadius * 0.9"
          [attr.x2]="islandCenter(n).x + islandRadius * 0.9"
          [attr.y2]="islandCenter(n).y - islandRadius * 0.9"
          stroke="#d00"
          stroke-width="3"
          stroke-linecap="round"
        />
        <!-- Check flash: highlight problematic islands -->
        <circle
          *ngIf="hasCheckError(n)"
          [attr.cx]="islandCenter(n).x"
          [attr.cy]="islandCenter(n).y"
          [attr.r]="islandRadius + 6"
          fill="none"
          stroke="#e53935"
          stroke-width="4"
        />
      </g>
    </g>
  </svg>
</div>
